// extracted by mini-css-extract-plugin
export var background = "bz_y";
export var backgroundContainer = "bz_fw";
export var bottomWave = "bz_cT";
export var buttons = "bz_cG";
export var container = "bz_b";
export var content = "bz_bQ";
export var icon = "bz_bv";
export var iconContainer = "bz_b3";
export var middleWave = "bz_cS";
export var negativeTop = "bz_gj";
export var overlap = "bz_gl";
export var section = "bz_d";
export var selected = "bz_bg";
export var tab = "bz_dQ";
export var tabText = "bz_dP";
export var title = "bz_h";
export var topWave = "bz_gk";